import React, { useEffect, useState, useRef } from 'react';
import { Container, Complemento } from './styles4';

import LogoErpWorks from "~/assets/logos/Logo ErpWorks Proposta.png";
import CheckUnChecked from "~/assets/logos/check_proposta_unchecked.png";

function Pagina4({ data, produtos }) {
  let linhas = "";//string.match(/(\r\n|\n|\r)/gm);
  let quantidadeLinhas = linhas ? linhas.length : 0;
  let resto = 0;

  return (
    <>
      <Container>
        <div className="barra-sup"></div>
        <div className="barra-sup2"></div>
        <div className="barra-sup3"></div>
        <div className="barra-sup4"></div>
        <div className="header">
          <div class="text">
            <p class="titulo">Data Emissão</p>
            <p class="titulo-data">{(new Date().toLocaleString('pt-BR', { timeZone: 'UTC' }))}</p>
          </div>
        </div>
        <div className="body">
          <div className="mid">
            <p class="titulo-orcamento">PAGAMENTO</p>
            <div class="text">
              <p class="titulo-list">Condições de Pagamento</p>
              <div class="list">
                <div className="item-cab">
                  <div className="col col8">
                    <p class="titulo-cab">Parcelas</p>
                  </div>
                  <div className="col col2 align-right">
                    <p class="titulo-cab">Valor</p>
                  </div>
                </div>
                {data?.condicoesPagamento?.map((itemCond, indexCond) => 
                  data?.tipoPagamento == "P" ? (
                    <div className="item">
                      <div className="col col04">
                        <img className="img-check" src={CheckUnChecked} alt="CheckUnChecked" />
                      </div>
                      <div className="col col76">
                        <p class="titulo">{(new Date(itemCond?.dataVencimento).toLocaleString('pt-BR', { timeZone: 'UTC' }))}</p>
                      </div>
                      <div className="col col2 align-right">
                        <p class="titulo">{(itemCond?.valor || 0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}</p>
                      </div>
                    </div>
                  ) : data?.tipoPagamento == "E" ? (
                    <div className="item">
                      <div className="col col04">
                        <img className="img-check" src={CheckUnChecked} alt="CheckUnChecked" />
                      </div>
                      <div className="col col76">
                        <p class="titulo">% {(itemCond?.percentualValor || 0)} {(indexCond == 0 ? " no inicio da atividade ": " na finalização da atividade ") + `"${itemCond?.orcamentoAtividade?.titulo}"`}</p>
                      </div>
                      <div className="col col2 align-right">
                        <p class="titulo">{(itemCond?.valor || 0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}</p>
                      </div>
                    </div>
                  ) : data?.tipoPagamento == "A" ? (
                    <div className="item">
                      <div className="col col04">
                        <img className="img-check" src={CheckUnChecked} alt="CheckUnChecked" />
                      </div>
                      <div className="col col3">
                        <p class="titulo">{`Dia ${(itemCond?.diasVencimento || 0)} a cada mês até o final do projeto`}</p>
                      </div>
                      <div className="col col66 align-right">
                        <p class="titulo">{"Apontamento de Horas * " + (itemCond?.valor || 0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}</p>
                      </div>
                    </div>
                  ) : (
                    <div className="item">
                      <div className="col col04">
                        <img className="img-check" src={CheckUnChecked} alt="CheckUnChecked" />
                      </div>
                      <div className="col col76">
                        <p class="titulo">{(itemCond?.diasVencimento || 0) <= 1 ? `% ${(itemCond?.percentualValor || 0)} no inicio` : `% ${itemCond?.percentualValor} a ${itemCond?.diasVencimento} dias DDL`}</p>
                      </div>
                      <div className="col col2 align-right">
                        <p class="titulo">{(itemCond?.valor || 0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}</p>
                      </div>
                    </div>
                  )
                )}
              </div>
            </div>
          </div>
          <div className="bottom">
            <div className="logo">
              <img className="logo-roda" src={LogoErpWorks} alt="Logo Erpworks" />
              <div className="text-roda">
                <pre>
                  Validade da proposta: {data?.diasVencimento} dias corridos a partir da data de emissão da proposta
                  <br />Formas de pagamento: {data?.tipoPagamento == "DP" ? "Depósito em conta corrente ou Pix" : "Depósito em conta corrente ou Pix"}.
                </pre>
              </div>
            </div>
            <div className="preco">
              <div className="descount">
                <div className="percent">
                  <p>{data?.percentualDesconto > 0 ? "-" + (data?.percentualDesconto || 0) + "%" : data?.horaTotal + " h(s)"}</p>
                </div>
                <p className="valor-descont">
                  {
                    data?.percentualDesconto > 0 
                    ? ((data?.valorTotal || 0) + (data?.valorDesconto || 0)).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
                    : ((data?.valorHora || 0)).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
                  }
                </p>
              </div>
              <div className="final-valor">
                <p className="valor-descont">{(data?.valorTotal || 0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}</p>
              </div>
            </div>
          </div>
        </div>
      </Container >
    </>
  );
};

export default Pagina4;